var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"contaier"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-5"},[_c('h5',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(_vm._s(_vm.description))]),_c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{
            name: _vm.routeName,
            params: {
              itemName: _vm.itemName
            }
          }}},[_vm._v("\n          Add object\n        ")])],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }